import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { organizationFindByTermSearchRequest } from "../../redux/actions/organizations";
import Icon from "../Icon";

const ComboBoxFindTerm = ({
  inputPlaceholder,
  selectedOrganization,
  organizationSelect,
  filterOption,
  id,
  date,
}) => {
  const dispatch = useDispatch();

  const [showList, setShowList] = useState(false);
  const [value, setValue] = useState("");
  const [change, setChange] = useState(false);
  // const list = useSelector((state) => state.organizations.list);

  const findBytermOrganization = useSelector((state) => state.organizations);

  const list = findBytermOrganization?.list;

  useEffect(() => {
    if (selectedOrganization) {
      setValue(selectedOrganization.organizationName);
    }
  }, [selectedOrganization]);

  useEffect(() => {
    // annoy selection trigger
    let values = { value, date };
    if (change) {
      dispatch(organizationFindByTermSearchRequest(values));
    }
  }, [value]);

  const elementSelect = (organization) => {
    setShowList(!showList);
    dispatch(organizationSelect(organization));
    setChange(false);
    setValue(organization.organizationName);
  };

  const inputChange = (e) => {
    if (e.target.value === "") {
      dispatch(organizationSelect({}));
    }
    setValue(e.target.value);
    setChange(true);
    setShowList(true);
  };

  const suffixIcon = () => {
    if (!value) return "search";
    else return "x";
  };

  const removeInput = () => {
    if (value) {
      setValue("");
      dispatch(organizationSelect({}));
      setChange(true);
    }
  };

  const filteredList = () => {
    let updatedList = [...list];
    if (filterOption) {
      updatedList = list.filter(
        (item) => item[filterOption.name] !== filterOption.value
      );
    }
    return listItems(updatedList);
  };

  const listItems = (list) =>
    list.map((item) => (
      <div
        key={item.organizationId}
        className="km__c--combobox-element"
        onClick={() => {
          elementSelect(item);
        }}
      >
        <div className="km__c--combobox-element-name">
          {item.organizationName}
        </div>
        <div className="km__c--combobox-element-id">
          ID: {item.organizationId}
        </div>
      </div>
    ));

  return (
    <div className="km__c--combobox-container">
      <div className="km__c--input-container">
        <input
          className="km__c--input km__c--input-has-icon"
          placeholder={inputPlaceholder}
          onClick={() => setShowList(!showList)}
          onChange={inputChange}
          value={value || ""}
          id={id}
          autoComplete="off"
        />
        <Icon
          name={suffixIcon()}
          className="km__c--combobox-remove-button"
          onClick={removeInput}
          size="16"
        />
      </div>
      {list.length > 0 && showList && (
        <div className="km__c--combobox-list">{filteredList()}</div>
      )}
    </div>
  );
};

export default ComboBoxFindTerm;
